import { type PollDataType } from './types';

export const getColumnSum = (data: number[][], index: number) =>
	data.reduce((acc, row) => acc + Number(row[index]), 0);

export const getTotalRowAfterDataTypeChange = (
	dataType: PollDataType,
	data: (string[] | number[])[]
) => {
	return dataType === 'number'
		? data[0].map((_, index) => getColumnSum(data.slice(1) as number[][], index))
		: Array(data[0].length).fill('');
};

export const updateArrayAtIndex = (arr, index, value) => {
	return [...arr.slice(0, index), value, ...arr.slice(index + 1)];
};
